const state = {
  ...window.__initialAppState.modules.cartPage
};

export default state;
